export const MARKET_TABS = [
    { value: "us", label: "US", flag: "🇺🇸", path: "/score/us" },
    { value: "cn", label: "China", flag: "🇨🇳", path: "/score/cn" },
    { value: "hk", label: "HK", flag: "🇭🇰", path: "/score/hk" },
    { value: "favor", label: "Favor", flag: "❤️", path: "/score/favor" },
];

const STORAGE_KEY = "tsmr_market_tab";

export function getStoredMarketTab() {
    if (typeof window === "undefined") {
        return "cn";
    }
    const saved = window.sessionStorage.getItem(STORAGE_KEY);
    return MARKET_TABS.some((tab) => tab.value === saved) ? saved : "cn";
}

export function rememberMarketTab(value) {
    if (typeof window !== "undefined" && MARKET_TABS.some((tab) => tab.value === value)) {
        window.sessionStorage.setItem(STORAGE_KEY, value);
    }
}

export function resolveMarketKey(pathname) {
    const path = String(pathname || "");
    if (path.startsWith("/score/us")) return "us";
    if (path.startsWith("/score/cn")) return "cn";
    if (path.startsWith("/score/hk")) return "hk";
    if (path.startsWith("/score/favor")) return "favor";

    // 详情页/分析页也带市场参数，但顶部 tab 只跟随用户上次手动选择，
    // 不能因为打开的是美股或 A 股个股就自动切 tab。
    return getStoredMarketTab();
}
